/** Current horizontal translate of a carousel track (px), for seamless chained animations. */
export function readCarouselTrackTranslateX(track: HTMLElement, fallbackX: number): number {
  const inline = track.style.transform
  const fromInline = /translate3d\(([-\d.e]+)px/i.exec(inline)
  if (fromInline) {
    const v = parseFloat(fromInline[1])
    if (Number.isFinite(v)) return v
  }
  const computed = window.getComputedStyle(track).transform
  if (computed && computed !== 'none') {
    return new DOMMatrixReadOnly(computed).m41
  }
  return fallbackX
}
